{
  "version": "0.0.5",
  "name": "@uxuycom/web3-tg-sdk",
  "description": "web3 sdk for tg",
  "main": "dist/index.es.js",
  "module": "dist/index.es.js",
  "jsdelivr": "dist/index.es.js",
  "typings": "dist/types/src/index.d.ts",
  "types": "dist/types/src/index.d.ts",
  "files": [
    "/dist",
    "/types",
    "tsconfig.json", 
    "tsconfig.node.json",
    "/example/my-react-app",
    "README.md"
  ],
  "keywords": [
    "evm",
    "cipherbrowser",
    "uxuySdkWallet",
    "ethereum",
    "wallet",
    "web3",
    "telegram",
    "uxuycom",
    "uxuy.com"
  ],
  "scripts": {
    "clean": "rimraf dist",
    "types": "tsc --outDir dist/types",
    "predev": "npm run clean && npm run types",
    "prebuild": "npm run clean && npm run types",
    "dev": "cross-env --NODE_ENV=development  node  ./scripts/esbuild.config.js",
    "build": "cross-env --NODE_ENV=production node  ./scripts/esbuild.config.js",
    "test": "jest ./tests/*",
    "lint": "",
    "prepare": "",
    "publish": "npm run build && npm publish" 
  },
  "prettier": {
    "printWidth": 80,
    "semi": true,
    "singleQuote": true,
    "trailingComma": "es5"
  },
  "devDependencies": {
    "@babel/core": "^7.23.0",
    "@babel/preset-env": "^7.22.20",
    "@babel/preset-react": "^7.22.15",
    "@babel/preset-typescript": "^7.23.0",
    "@types/node": "^20.4.5",
    "@types/node-fetch": "^2.6.4",
    "cross-env": "^7.0.3",
    "crypto-browserify": "^3.12.0",
    "esbuild": "^0.18.10",
    "jest": "^29.7.0",
    "process": "^0.11.10",
    "qs": "^6.13.0",
    "rimraf": "^5.0.1",
    "stream-browserify": "^3.0.0",
    "ts-node": "^10.9.1",
    "typescript": "^5.1.6",
    "uuid": "^9.0.0",
    "vm-browserify": "^1.1.2"
  },
  "dependencies": {
    "axios": "^1.5.0",
    "buffer": "^6.0.3",
    "eventemitter3": "^5.0.1"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "author": "uxuySafe",
  "license": "ISC"
}

